// what a signed-in session carries; stored in Redis, never in the browser
export type SessionAudience = 'player' | 'admin';
export type SessionRecord = {
  id: string;
  userId: string;
  audience: SessionAudience;
  csrfToken: string;
  createdAt: string;
  rotatedAt: string;
  lastActiveAt?: string;
  // when this session last passed two-step login (admins only)
  twoStepVerifiedAt?: string;
  // set on the short-lived copy left behind after a rotation, and on the new record pointing back
  replacedBy?: string;
  previousId?: string;
  expiresAt: string;
  userAgent: string | null;
  ip: string | null;
};
export const SESSION_COOKIE = { player: 'll_session', admin: 'll_admin_session' } as const;
export const CSRF_HEADER = 'x-csrf-token';
